import { useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { Menu, BookOpen, CalendarDays, Mic, Settings, Lock, LogOut } from "lucide-react";
import { Sheet, SheetContent, SheetTrigger, SheetTitle, SheetDescription } from "./ui/sheet";
import { useAuth } from "../context/AuthContext";
import { useI18n } from "../context/I18nContext";

const LINKS = [
  { to: "/journal", key: "nav_journal", icon: BookOpen, end: true },
  { to: "/calendar", key: "nav_calendar", icon: CalendarDays },
  { to: "/record", key: "nav_record", icon: Mic },
  { to: "/settings", key: "nav_settings", icon: Settings },
];

const itemCls = "flex items-center gap-4 px-4 py-3.5 rounded-xl text-base transition-colors duration-200";

export const MobileMenu = () => {
  const { user, logout, lock } = useAuth();
  const { t } = useI18n();
  const nav = useNavigate();
  const [open, setOpen] = useState(false);
  const close = () => setOpen(false);

  return (
    <Sheet open={open} onOpenChange={setOpen}>
      <SheetTrigger asChild>
        <button data-testid="mobile-menu-btn" className="sm:hidden w-9 h-9 rounded-full border border-[#E5C158]/30 grid place-items-center text-[#E5C158]" aria-label="Menu">
          <Menu size={18} />
        </button>
      </SheetTrigger>
      <SheetContent side="right" data-testid="mobile-menu" className="bg-[#0C1322] border-l border-[#E5C158]/20 text-[#F4F6FA] w-[82%] flex flex-col">
        <SheetTitle className="font-serif text-3xl text-[#F4F6FA] mt-2">Écho</SheetTitle>
        <SheetDescription className="text-xs text-[#8E9BB4] -mt-2">{user.email}</SheetDescription>
        <nav className="flex flex-col gap-1 mt-6">
          {LINKS.map(({ to, key, icon: Icon, end }) => (
            <NavLink
              key={to}
              to={to}
              end={end}
              onClick={close}
              data-testid={`mobile-nav-${to.slice(1)}`}
              className={({ isActive }) => `${itemCls} ${isActive ? "bg-[#E5C158]/10 text-[#E5C158]" : "text-[#C2C9DB] hover:bg-white/5"}`}
            >
              <Icon size={19} strokeWidth={1.6} /> {t(key)}
            </NavLink>
          ))}
        </nav>
        <div className="mt-auto flex flex-col gap-1 border-t border-white/5 pt-4">
          {user.pin_enabled && user.pin_unlocked && (
            <button data-testid="mobile-lock-btn" onClick={() => { close(); lock(); }} className={`${itemCls} text-[#E5C158] hover:bg-[#E5C158]/10`}>
              <Lock size={19} strokeWidth={1.6} /> {t("pin_lock_now")}
            </button>
          )}
          <button data-testid="mobile-logout-btn" onClick={async () => { close(); await logout(); nav("/"); }} className={`${itemCls} text-[#8E9BB4] hover:bg-white/5`}>
            <LogOut size={19} strokeWidth={1.6} /> {t("nav_logout")}
          </button>
        </div>
      </SheetContent>
    </Sheet>
  );
};
